<div class="fc-image-container">
    <img [src]="src | getSafeImageUrl | async" class="fc-image" [alt]="alt || ''" data-e2e-hook="image" />
</div>
